import { useSelector } from "react-redux";

import { useGetPlatformsQuery } from "state/rtkQuery/platform/platformQueries";

// The platform Access Management works against: the one picked in the ECR Ops
// platform selector, falling back to the default platform until that resolves
// (same rule as the Org Management page). Used to scope the organization list
// and sent as platform_id on role-assignment updates.
export const useAccessPlatformId = () => {
  const { data: platformData, isFetching } = useGetPlatformsQuery();
  const selectedPlatformId = useSelector((state) => state.ecrOpsPlatform?.selectedPlatformId);
  return { platformId: selectedPlatformId || platformData?._id, isLoadingPlatform: isFetching };
};
